import { useNavigate, useLocation } from "react-router-dom";
import Form from "../form/Form";
import StatsSection from "./StatsSection";

const Hero = ({ metrics = [], loading = false }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToCatalogue = () => {
    const scroll = () => {
      const element = document.getElementById("catalogue");
      if (!element) return;

      const headerOffset = 90;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    };

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(scroll, 100);
    } else {
      scroll();
    }
  };

  return (
    <section className="relative w-full bg-black overflow-hidden px-6 md:px-12 flex justify-center flex-col ">
      {/*  BACKGROUND  */}
      <div className="absolute inset-0 z-0">
        <img
          src="./images/alldoer-hero.png"
          alt="Shipping Containers Port"
          className="w-full h-full object-cover"
        />

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent" />
      </div>

      {/*  HERO CONTENT  */}
      <div className="relative z-10 flex items-center min-h-screen">
        <div className="w-full max-w-[1440px] mx-auto py-20 lg:py-28">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            {/* LEFT */}
            <div className="text-white max-w-xl space-y-6">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-normal leading-tight">
                We Source. We QC.
                <br />
                <span className="text-neutral-400">We Ship Globally.</span>
              </h1>

              <p className="text-base md:text-lg text-gray-100 leading-relaxed">
                Alldoer is your custom sourcing agency. We deliver corporate
                uniforms and festive decor worldwide.
              </p>

              <div className="pt-4">
                <button
                  onClick={scrollToCatalogue}
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-[4px] flex items-center font-medium transition-colors"
                >
                  Explore Capabilities
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 14l-7 7m0 0l-7-7m7 7V3"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* RIGHT */}
            <div className="w-full">
              <Form />
            </div>
          </div>
        </div>
      </div>

      {/* STATS SECTION*/}
      <StatsSection metrics={metrics} loading={loading} />
    </section>
  );
};

export default Hero;
